import { LineChart } from "@mui/x-charts";
import React, { CSSProperties, useEffect, useState } from "react";
import { ShootingsDTO } from "../../interfaces/ShootingsDTO";
import axios from "axios";
import { useHeartrates } from "../../services/shootingHeartRate";
import {
  PulseBeautifiedDTO,
  PulseDTO,
  PulseShootingBeautifiedDTO,
} from "../../interfaces/PulseDTO";

interface Props {
  shootings: {
    [key: number]: ShootingsDTO;
  } | null;
  startno: number;
}
function GetNumberArray(inp: PulseBeautifiedDTO[]): Array<number | null> {
  let ret: Array<number | null> = Array(40).fill(null);

  inp.map((val) => {
    if (val.timeprocess < ret.length) {
      ret[val.timeprocess] = val.heartrate;
    }
  });

  return ret;
}

const BiosShootingDiagram = ({ shootings, startno }: Props) => {
  const [shooting1, setShooting1] = useState<Array<number | null>>(
    Array(40).fill(null)
  );
  const [shooting2, setShooting2] = useState<Array<number | null>>(
    Array(40).fill(null)
  );
  const [shooting3, setShooting3] = useState<Array<number | null>>(
    Array(40).fill(null)
  );
  const [shooting4, setShooting4] = useState<Array<number | null>>(
    Array(40).fill(null)
  );
  const { pulse, handlePulse } = useHeartrates();

  useEffect(() => {
    handlePulse(startno, shootings);
  }, [shootings]);

  useEffect(() => {
    setShooting1(Array(40).fill(null));
    setShooting2(Array(40).fill(null));
    setShooting3(Array(40).fill(null));
    setShooting4(Array(40).fill(null));
    pulse.map((val) => {
      // val.shootingPos
      if (val.shootingPos === 1) {
        setShooting1(GetNumberArray(val.pulsePass));
      } else if (val.shootingPos === 2) {
        setShooting2(GetNumberArray(val.pulsePass));
      } else if (val.shootingPos === 3) {
        setShooting3(GetNumberArray(val.pulsePass));
      } else if (val.shootingPos === 4) {
        setShooting4(GetNumberArray(val.pulsePass));
      }
    });
  }, [pulse]);

  const listStyle:CSSProperties  = {
    listStyleType: 'none',
    paddingLeft: '20px'
  };

  const listItemStyle:CSSProperties = {
    position: 'relative',
    paddingLeft: "20px"
  };

  const bulletPointStyle:CSSProperties = {
    content: '""',
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '15px',
    height: '15px',
    backgroundColor: 'red', // Change to your desired color
  };


  if (shootings === null) {
    return <></>;
  }
  // data: [
  //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
  //   20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
  //   36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
  // ],
  return (
    <div>
      <h4 style={{paddingLeft: "20px"}}>Puls</h4>
      <LineChart
      sx={{
        '& .MuiLineElement-root': {
          strokeWidth: 4,
        },
        '& .MuiAreaElement-series-Germany': {
          fill: "url('#myGradient')",
        },
      }}

        xAxis={[
          {
            data: [
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
              36, 37, 38, 39, 40
            ],
          },
        ]}
        series={[
          {
            data: shooting1,
            showMark: false,
            color: "#7cbdb9",
            area: false,
          },
          {
            data: shooting2,
            showMark: false,
            color: "#6165ad",
            area: false,
          },
          {
            data: shooting3,
            showMark: false,
            color: "#ddaf35",
            area: false,
          },
          {
            data: shooting4,
            showMark: false,
            color: "#d47a2c",
            area: false,
          },
        ]}
        width={400}
        height={300}
      />
      <div>
        <div style={{paddingLeft: "20px"}}>Shootings color</div>
        <ul style={listStyle}>
        <li style={listItemStyle}><span style={{ ...bulletPointStyle, backgroundColor: "#7cbdb9" }}></span>Shooting 1</li>
        <li style={listItemStyle}><span style={{ ...bulletPointStyle, backgroundColor: "#6165ad" }}></span>Shooting 2</li>
        <li style={listItemStyle}><span style={{ ...bulletPointStyle, backgroundColor: "#ddaf35" }}></span>Shooting 3</li>
        <li style={listItemStyle}><span style={{ ...bulletPointStyle, backgroundColor: "#d47a2c" }}></span>Shooting 4</li>
      </ul>

      </div>
    </div>
  );
};

export default BiosShootingDiagram;
